/** "Best angle" badge beside the overall score (spec §5; 2+ angles only). */
import { bestAngle } from "@/lib/angles";
import type { FacetSummary } from "@/types/concept";
import type { PaperWithRole } from "@/types/paper";

export function BestAngleBadge({ paper, angles }: { paper: PaperWithRole; angles: FacetSummary[] | undefined }) {
  if (!angles || angles.length < 2) return null;
  const best = bestAngle(paper, angles);
  if (!best) return null;
  return (
    <span
      title={`Best angle: ${best.label} (${best.score})`}
      className="ml-1 min-w-0 shrink truncate rounded bg-muted px-1 py-0.5 text-[10px] text-muted-foreground"
    >
      {best.label}
    </span>
  );
}
